import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { TID } from "@/lib/testIds";

const cols = [
  {
    title: "Platform",
    links: [
      ["Songwriters", "/app/songwriters"],
      ["Music Industry", "/app/music-industry"],
      ["Services", "/app/services"],
      ["Merchandising", "/app/merchandising"],
    ],
  },
  {
    title: "Experience",
    links: [
      ["Radio", "/app/radio"],
      ["Workshops", "/app/workshops"],
      ["Membership", "#membership"],
      ["FAQ", "#faq"],
    ],
  },
  {
    title: "Account",
    links: [
      ["Sign In", "/login"],
      ["Join", "/register"],
      ["Support", "#"],
      ["Privacy", "#"],
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer
      data-testid={TID.landing.footer}
      className="border-t border-white/10 bg-matte relative"
    >
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="space-y-5">
          <Logo variant="inline" size={36} />
          <p className="text-white/50 text-sm max-w-xs leading-relaxed">
            A professional ecosystem where the song comes first. Ownership
            preserved. Discovery without popularity bias.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="font-display uppercase text-[11px] tracking-[0.4em] text-gold mb-4">
              {c.title}
            </div>
            <ul className="space-y-2">
              {c.links.map(([label, to]) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-[11px] uppercase tracking-[0.35em] text-white/40 font-display">
            © {new Date().getFullYear()} Songwriter Square
          </div>
          <div className="text-[11px] uppercase tracking-[0.35em] text-white/40 font-display">
            The Song Comes First
          </div>
        </div>
      </div>
    </footer>
  );
}
